import { Box, Typography } from '@mui/material';
import Spinner from 'components/spinner';

import { styles } from './styles';

export const SelectAudienceLoadingButton = () => {
  return (
    <Box sx={[styles.button, { cursor: 'default' }]}>
      <Spinner size={15} minHeight={'20px'} />
      <Typography sx={styles.buttonText}>Loading...</Typography>
    </Box>
  );
};
